import React from 'react';

import {
	Heading,
	Spacer,
	FormControl,
	FormLabel,
	Checkbox,
	useDisclosure,
	Stack,
	VStack
} from '@chakra-ui/react';

import { DeliveringZeroesMessage } from '../components/DeliveringZeroesMessage';
import { AllDueDatesTable, DuplicateExceptionModal } from '../components/DueDatesTable';
import { HelpCenterMessage } from '../components/HelpCenterMessage';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
	selectDuplicatingStudentException,
	selectShowStudentExceptions,
	setShowStudentExceptions
} from '../store/uiSlice';

const AllDueDates: React.FC = () => {
	const dispatch = useAppDispatch();
	const showStudentExceptions = useAppSelector(selectShowStudentExceptions);
	const duplicatingStudentException = useAppSelector(selectDuplicatingStudentException);
	const { isOpen: isDuplicateModalOpen } = useDisclosure({
		isOpen: Boolean(duplicatingStudentException)
	});

	return (
		<VStack justify="flex-start" align="flex-start" spacing={[6, 8]} mt="4">
			<Stack
				direction={{ base: 'column', md: 'row' }}
				w="100%"
				justify={'space-between'}
				alignItems={{ base: 'flex-start', md: 'center' }}>
				<Heading as="h2" lineHeight={1}>
					All your course due dates
				</Heading>
				<Spacer />
				<FormControl display="flex" w="auto" alignItems="center" flexDirection="row-reverse">
					<FormLabel mb="0" mr="0" aria-hidden="true">
						Show student exceptions
					</FormLabel>
					<Checkbox
						mr="2"
						aria-label="Show student exceptions"
						isChecked={showStudentExceptions}
						onChange={() => dispatch(setShowStudentExceptions(!showStudentExceptions))}
					/>
				</FormControl>
			</Stack>

			<HelpCenterMessage />

			<AllDueDatesTable />

			<DeliveringZeroesMessage />

			<DuplicateExceptionModal isOpen={isDuplicateModalOpen} />
		</VStack>
	);
};

export default AllDueDates;
